<template>
  <div data-uk-dropdown="{mode:'click'}"
       class="uk-button-dropdown">
    <slot></slot>
    <div class="uk-dropdown">
      <ul class="uk-nav uk-nav-dropdown">
        <li v-for="item in items"
            :class="{'uk-nav-header':item.isHeader}">
          <a @click.prevent="selectItem(item)">{{ item[textField] }}</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'UkDropdown',
    props: {
      items: {
        type: Array,
        default: () => []
      },
      textField: {
        type: String,
        default: 'label'
      },
      valueField: {
        type: String,
        default: 'value'
      }
    },
    data () {
      return {
        selectedItem: undefined
      }
    },
    computed: {
      selectedValue (){
        return this.selectedItem ? this.selectedItem[this.valueField] : ''
      }
    },
    methods: {
      selectItem(item) {
        this.selectedItem = item
        this.$emit('change', item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UkDropdown.vue?d4c8ba3a